/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstylesouthwest4Inputs */



/**
* | output |
* | --- |
* | "Self-Sarcastic" |
*
* @param {Personalityhumorstylesouthwest4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstylesouthwest4 = /** @type {((inputs?: Personalityhumorstylesouthwest4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstylesouthwest4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Self-Sarcastic")
	if (locale === "es") return /** @type {LocalizedString} */ ("Autosarcástico")
	return /** @type {LocalizedString} */ ("Самосарказм")
});
export { personalityhumorstylesouthwest4 as "personalityHumorStyleSouthWest" }